import { render, staticRenderFns } from "./Jizhais.vue?vue&type=template&id=73344f4a&scoped=true"
import script from "./Jizhais.vue?vue&type=script&lang=js"
export * from "./Jizhais.vue?vue&type=script&lang=js"
import style0 from "./Jizhais.vue?vue&type=style&index=0&id=73344f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73344f4a",
  null
  
)

export default component.exports